import { shipmentStopRoleFromIndex } from '@gpx-spa/constants'
import { z } from 'zod'
import type { ShipmentFormStopRow } from '@/stores/useShipmentFormStore'
import { getStopRoutingCoordinates } from '@/components/shipment/form/utils/shipment-form-stop-coords'

const latLngSchema = z.object({
  lat: z.number().finite(),
  lng: z.number().finite(),
})

export type ShipmentFormStopFieldKey = 'location' | 'plannedDeparture' | 'plannedArrival'

export type ShipmentFormStopFieldErrors = Partial<
  Record<ShipmentFormStopFieldKey, string>
>

export function isValidPlannedDate(d: Date | null | undefined): boolean {
  return d instanceof Date && !Number.isNaN(d.getTime())
}

const MSG_LOCATION = 'Select a geofence or enter and resolve a street address.'
const MSG_DEPARTURE = 'Set planned departure.'
const MSG_ARRIVAL = 'Set planned arrival.'

/**
 * Per-field client messages for Save (empty object = valid).
 */
export function getShipmentFormStopFieldErrors(
  stop: ShipmentFormStopRow,
  index: number,
  totalStops: number
): ShipmentFormStopFieldErrors {
  const out: ShipmentFormStopFieldErrors = {}

  const coords = getStopRoutingCoordinates(stop)
  const validCoords = coords != null && latLngSchema.safeParse(coords).success
  if (!validCoords) {
    out.location = MSG_LOCATION
  }

  const role = shipmentStopRoleFromIndex(index, totalStops)
  const needDeparture = role === 'origin' || role === 'waypoint'
  const needArrival = role === 'destination' || role === 'waypoint'

  if (needDeparture && !isValidPlannedDate(stop.plannedDeparture)) {
    out.plannedDeparture = MSG_DEPARTURE
  }
  if (needArrival && !isValidPlannedDate(stop.plannedArrival)) {
    out.plannedArrival = MSG_ARRIVAL
  }

  return out
}

export function clientKeyForStopField(stopIndex: number, field: ShipmentFormStopFieldKey): string {
  return `stop_${stopIndex}_${field}`
}
